module.exports = {
  constructorMethods: require("./constructorMethods"),
  bootstrap: require("./bootstrap"),
  properties: require("./properties")
};



//////////////////
// WEBPACK FOOTER
// ./~/truffle-contract/lib/contract/index.js
// module id = 1nE5
// module chunks = 0